const debug = false

let languageJSON = undefined
let clientSpecificJSON = undefined

function translateKey(key, original = 'NA', params = []) {
  if (languageJSON || clientSpecificJSON) {
    let translation = clientSpecificJSON[key] || languageJSON[key] || (debug ? '===== MISSING KEY =====' : original)

    if (translation.includes('{1}') && params.length > 0) {
      //check if translation contains placeholders

      params.forEach((value, index) => {
        translation = translation.replace(new RegExp('\\{' + (index + 1) + '\\}', 'g'), value)
      })

      return translation
    }

    return translation
  }
}

function loadLanguageJSON(lang = 'en') {
  const language = lang
  const userInfo = localStorage.getItem('userInfo') && JSON.parse(localStorage.getItem('userInfo'))
  let clientRef = (userInfo && userInfo['clientRef'] && userInfo['clientRef'].toLowerCase()) || null

  languageJSON = require('../locales/' + language + '/translation.json')

  try {
    // Temporary fix to load DPD translations for DPD baltics/be.
    if (clientRef.includes('dpd') && clientRef !== 'dpduk' && clientRef !== 'dpdpl' && clientRef !== 'dpdde') {
      clientRef = 'dpd'
    }
    // Temporary fix to load DPD UK translations.
    if (clientRef === 'demouk') {
      clientRef = 'dpduk'
    }
    clientSpecificJSON = require('../locales/clientSpecific/' + clientRef + '/' + language + '/translation.json')
  } catch (err) {
    clientSpecificJSON = ''
  }

  // console.log('LANGUAGE:', language)
  // console.log('LANGUAGE JSON:', languageJSON)
  // console.log('CLIENT SPECIFIC JSON:', clientSpecificJSON)
}

export { loadLanguageJSON, translateKey }
